import styles from './LockBanner.module.scss';
import PremiumLock from './PremiumLock';

export const LockBanner = ({ isLoggedIn }: { isLoggedIn?: boolean }) => (
  <div className={styles.lockBanner}>
    {isLoggedIn ? (
      <span data-testid="unlocked-header">unlocked</span>
    ) : (
      <span data-testid="locked-header">
        <PremiumLock />
        log in to view for free
      </span>
    )}
  </div>
);
